(function() {

  var $self = this;
  $self.ProjectsAndPartnerships          = $self.ProjectsAndPartnerships          || {};
  $self.ProjectsAndPartnerships.projects = $self.ProjectsAndPartnerships.projects || {};

  $self.ProjectsAndPartnerships.projects.awardsData = [
    // map 1
    {
      id: 118,
      // city, state: columbus, oh
      textParams: {
        posModX: function(c) {return c - 80; },
        posModY: function(c) {return c + 4; }
      }
    },
    {
      id: 123,
      // city, state: morgantown, wv
      textParams: {
        posModX: function(c) {return c + 3; },
        posModY: function(c) {return c - 4; }
      }
    },
    {
      id: 119,
      // city, state: reading, pa
      textParams: {
        posModX: function(c) {return c + 8; },
        posModY: function(c) {return c + 4; }
      }
    },
    {
      id: 128,
      // city, state: arlington, va
      textParams: {
        posModX: function(c) {return c + 8; },
        posModY: function(c) {return c + 4; }
      }
    },

    // map 2
    {
      id: 86,
      // city, state: washington d.c.
      textParams: {
        posModX: function(c) {return c + 8; },
        posModY: function(c) {return c + 4; }
      }
    },
    {
      id: 138,
      // city, state: washington d.c.
      textParams: {
        posModX: function(c) {return c + 8; },
        posModY: function(c) {return c + 4; }
      }
    },
    {
      id: 89,
      // city, state: philadephia, pa
      textParams: {
        posModX: function(c) {return c + 8; },
        posModY: function(c) {return c + 4; }
      }
    },
    {
      id: 99,
      // city, state: austin, tx
      textParams: {
        posModX: function(c) {return c - 25; },
        posModY: function(c) {return c + 15; }
      }
    },
    {
      id: 85,
      // city, state: houston, tx
      textParams: {
        posModX: function(c) {return c - 10; },
        posModY: function(c) {return c + 15; }
      }
    },
    {
      id: 76,
      // city, state: madison, wi
      textParams: {
        posModX: function(c) {return c - 70; },
        posModY: function(c) {return c + 4; }
      }
    },

    // map3
    {
      id: 130,
      // city, state: new york, ny
      textParams: {
        posModX: function(c) {return c + 8; },
        posModY: function(c) {return c + 4; }
      }
    },

    // map 4
    {
      id: 90,
      // city, state: diamondbar, ca
      textParams: {
        posModX: function(c) {return c - 30; },
        posModY: function(c) {return c - 8; }
      }
    },
    {
      id: 81,
      // city, state: indianapolis, in
      textParams: {
        posModX: function(c) {return c - 85; },
        posModY: function(c) {return c + 4; }
      }
    },
    {
      id: 71,
      // city, state: albany, ny
      textParams: {
        posModX: function(c) {return c + 8; },
        posModY: function(c) {return c + 4; }
      }
    },
    {
      id: 68,
      // city, state: newhaven, ct
      textParams: {
        posModX: function(c) {return c + 8; },
        posModY: function(c) {return c + 4; }
      }
    },
  ];


}).call(CC);